import React, { Component } from 'react';
import {
	HeaderView,
	FooterView,
	PricingView,
	FreeTrialView,
	GetInTouchView,
	ContactUsView,
} from './components/views';

class PricingPage extends Component {
	componentDidMount () {
		window.scrollTo(0, 0);
	}

	render () {
		return (
			<main>
				<HeaderView opaque={true} />
				<FreeTrialView />
				<PricingView />
				<GetInTouchView />
				<ContactUsView />
				<FooterView />
			</main>
		);
	}
}

export default PricingPage;



// WEBPACK FOOTER //
// ./src/PricingPage.js